import "fix-date"
import format from "date-fns/format"
import isAfter from "date-fns/isAfter"
import formatDistanceToNow from "date-fns/formatDistanceToNow"
import formatDate from "date-fns/format"

export const parseMillis = (dateString: string) => {
    if (!/^\d+$/.test(dateString)) return dateString
    const parsed = parseInt(dateString, 10)
    return isNaN(parsed) ? dateString : parsed
}

export const shortMonthDate = (dateString: string): string => {
    if (!dateString) return ""

    return format(new Date(parseMillis(dateString)), "D MMM Y")
}

export const shortDate = (dateString: string): string => {
    if (!dateString) return ""

    return format(new Date(dateString), "yyyy-MM-dd")
}

export const msToFormattedTime = (milliseconds: number): string => {
    if (milliseconds < 60000) {
        return `${Math.round(milliseconds / 1000)} seconds`
    }
    return formatDistanceToNow(new Date((new Date() as any) - milliseconds), {
        includeSeconds: true
    }).replace("about ", "")
}

export function fromNow(date: string | Date) {
    const distanceToNow = (
        date instanceof Date
            ? formatDistanceToNow(date)
            : formatDistanceToNow(new Date(date))
    ).replace("about ", "")

    return distanceToNow === "less than a minute"
        ? "Just now"
        : `${distanceToNow} ago`
}

export function longDateTimeFormat(date: string | Date): string {
    return formatDate(new Date(date), "HH:mm 'on' d MMM yyyy")
}

export function relativeAndAbsoluteDateTime(date: string | Date): string {
    return `${fromNow(date)} (${longDateTimeFormat(date)})`
}

export function stringToISODate(date: string) {
    return new Date(date).toISOString()
}

export function takeLast(oneDate: string, ...otherDates: string[]): string {
    return [oneDate, ...otherDates].sort(compareDate)[otherDates.length]
}

export function takeFirst(oneDate: string, ...otherDates: string[]): string {
    return [oneDate, ...otherDates].sort(compareDate)[0]
}

export function assertValidDate(str: string): void {
    if (Number.isNaN(+new Date(str))) {
        throw Error("Invalid date format.")
    }
}

function compareDate(oneDate: string, anotherDate: string): number {
    const one = new Date(oneDate)
    const another = new Date(anotherDate)

    return isAfter(one, another) ? 1 : -1
}
